import {FC} from "react";
import {Outlet} from "react-router-dom";
import AdminFooter from "./admin/AdminFooter";
import {useAuth} from "./AuthContext"
import AdminNavbar from "./admin/AdminNavbar";
import {RequireAuth} from "./RequireAuth";
import {AuthenticatedProviders} from "../providers/AuthenticatedProviders";

export const AuthenticatedLayout: FC = () => {
    const {isLoggedIn} = useAuth();

    return (
        <RequireAuth>
            <AuthenticatedProviders>
                <div className="flex flex-col h-screen justify-between">
                    <AdminNavbar/>
                    <div className="bg-gray-100 h-sreen flex-grow">
                        <main className="container mx-auto flex-grow">{isLoggedIn && <Outlet/>}</main>
                    </div>
                    <AdminFooter/>
                </div>
            </AuthenticatedProviders>
        </RequireAuth>
    );
};
// };